import { DE_LOCALE } from './i18n';
import { getCookie } from '../api/lendingApi/lendingApiQueries';

export const isIwocaDE = () => {
  // Prefer `host` (includes port) but fall back to `hostname` so tests that
  // partially mock `window.location` with only one of the two still work.
  const host = window.location.host || window.location.hostname;

  const isDELocale =
    hostIncludesDeLocale(host) || getCookie('locale') === DE_LOCALE;

  return isDELocale;
};

export const hostIncludesDeLocale = (host?: string) => {
  if (!host) return false;

  return host.includes(`.${DE_LOCALE}`);
};
